export default "__VITE_ASSET__Dih0EWZf__"